package system.network

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.*
import input.*
import kotlinx.coroutines.channels.*
import models.*

class NetworkOutputSystem(
    private val channel: Channel<PlayerCommands> = Channel(capacity = Channel.Factory.UNLIMITED),
    private val inputController: InputController = World.inject()
) : IteratingSystem(family { all(PlayerComponent) }) {

    suspend fun readEvents(body: suspend (PlayerCommands) -> Unit) {
        for (event in channel) {
            body(event)
        }
    }

    override fun onTickEntity(entity: Entity) {
        val commands = inputController.toPlayerCommands()
        channel.trySend(commands)
    }

    private fun InputController.toPlayerCommands() = PlayerCommands(
        left = left.current,
        right = right.current,
        up = jump.current,
        down = down.current
    )
}
